<div [style.height.px]="height">
  @if (headerType === HeaderType.Landing && showHeader) {
  <app-header-landing />
  }
</div>
